export class Attemp {
    partOne: AttempArray;
    partTwo: AttempArray;
    constructor(values: Object = {}) {
        Object.assign(this, values);
    }
}

export class AttempArray {
    total: Array<any>;
    versions: Array<any>;
    constructor(values: Object = {}) {
    }
}

export class NewAttempt{
    attempt : string;
    marks : number;
    constructor(values: Object = {}) {
        Object.assign(this, values);
    }
}



// WEBPACK FOOTER //
// /usr/share/nginx/grade5_live/grade5-frontend-2.0/src/app/core-modules/model/Attemp.ts